import { rei } from "@/services/api"


class ProvimentoTrezeService {
  
  //ibter descem pedidos pednentes da api
  static obterPedidosPendentes () {
    return rei.get(`provimento-treze/obter-pedidos-pendentes-p13`)
  }

  //obtem pedidos que desceram da api e estão salvos no banco
  static obterPedidosSalvos () {
    return rei.get(`provimento-treze/obter-pedidos-salvos`)
  }

  static updateNascimentoId (pedido, nascimentoId) {
    return rei.post(`provimento-treze/update-id-nascimento`, {pedido, nascimentoId})
  }

static enviarPedido (assinatura, pedido, emolumentos, osSelected) {
    return rei.post(`provimento-treze/enviar-pedido`, {assinatura , pedido, emolumentos, osSelected})
  }

static obterPedidoById (numero) {
    return rei.post(`provimento-treze/obter-pedido-by-id`, { numero })
}

  
//   static enviarPedido(assinatura, pedido, emolumentos, osSelected){
//     return rei.post(`certidoes-crc/enviar-pedido`, {assinatura , pedido, emolumentos, osSelected})
//   }
  


  // static cumprirPedidosPendentes (certidoes) {
  //   return rei.post('certidao/cumprir-pedidos-pendentes-crc', certidoes).then(res => res.data)
  // }
}

export default ProvimentoTrezeService